/*eslint-disable */

import {createSlice} from '@reduxjs/toolkit'


const initialState = {
    employees : [],
    selectedEmployee : null,
   
}

const employeeSlice = createSlice({
    name : "employee",
    initialState: {...initialState, page:1},  

    reducers : {
        addEmployee : (state, action) => {
            state.employees.push(action.payload)
        },
        setEmployees : (state, action) => {
            state.employees = action.payload
        },
        updateEmployee : (state,action) => {
            const {id,data} = action.payload
            const index = state.employees.findIndex(emp => emp.pk === id );
            if(index!== -1){
                state.employees[index] = {...state.employees[index], ...data}
            }
        },
        setSelectedEmployee : (state,action) => {
            state.selectedEmployee = action.payload
        },
        clearSelectedEmployee  : (state , action) => {
            state.selectedEmployee = null;
        },
        handlePage: (state, action) => {
      
         state.page = action.payload
    },
    }
})


export const {addEmployee, setEmployees,updateEmployee,setSelectedEmployee,clearSelectedEmployee, handlePage } = employeeSlice.actions
export default employeeSlice.reducer